var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-dialog",
    {
      attrs: {
        icon: "/static/mail-purple.svg",
        title: "Verifique seu e-mail!",
        visible: _vm.visible
      }
    },
    [
      _c("p", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Informe seu e-mail abaixo para prosseguir com a compra.")
      ]),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            }
          ],
          class: { "has-error": _vm.errors.has("email") },
          attrs: {
            type: "email",
            name: "email",
            placeholder: "informe o e-mail cadastrado"
          },
          domProps: { value: _vm.email },
          on: {
            keyup: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.send($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.has("email")
          ? _c("small", {
              domProps: { innerHTML: _vm._s(_vm.errors.first("email")) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group mt-10" }, [
          _c(
            "div",
            {
              staticClass: "btn bg-purple-outline",
              on: {
                click: function($event) {
                  _vm.openFreshdesk()
                }
              }
            },
            [_vm._v("solicitar alteração")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn bg-purple",
              class: { "btn--loading": _vm.loader },
              on: { click: _vm.send }
            },
            [_c("span", [_vm._v("confirmar e-mail")])]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28b387db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b387db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/EmailNotVerified/Dialog.vue
// module id = null
// module chunks = 